import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("PingTest");

// only for fixing HTML-1826, this class has been deleted in AS
export class PingTest {
    constructor(ip: string, port: number, zone: string, blueBox: number, callback: Function) {
        logger.warn("PinTest constructor is not implemented.");
    }
}
